import React from 'react';

import fetchContent from '../../helpers/backend-communication';

import CountryAssistanceSeekingPOAPanel from './CountryAssistanceSeekingPOAPanel';

class CountryAssistanceSeekingPOA extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      assistanceNeeds: null,
      reportSourceYear: null
    };
  }

  componentDidMount() {
    this.fetchAssistanceNeedsFromPoA();
  }

  fetchAssistanceNeedsFromPoA() {
    const queryString = '?country__iso_alpha_3=' + this.props.countryCode;

    this.props.onLoading(true);
    fetchContent('assistanceSeekers', queryString)
      .then(responseObject => {
        const data = responseObject.data;
        if (!data || data.length === 0) {
          return Promise.reject();
        }
        this.setState({
          assistanceNeeds: this.formatAssistanceNeeds(data[0].attributes.assistanceNeeds),
          reportSourceYear: data[0].attributes.reportSourceYear
        });
        this.props.onLoading(false);
      })
      .catch(error => {
        console.error('Fetch went wrong', error);
        this.props.onLoading(false);
      });
  }

  formatAssistanceNeeds(data) {
    const formattedData = {
      Request: [],
      Provided: [],
      Received: []
    };

    data.forEach(item => {
      const flag = item.attributes.flag;

      if (flag !== 'N/A' && item.attributes.value) {
        formattedData[flag || 'Request'].push(item);
      }
    });

    return formattedData;
  }

  renderPanels() {
    const assistanceNeeds = this.state.assistanceNeeds;
    return Object.keys(assistanceNeeds).map(key => {
      const data = assistanceNeeds[key];

      return (
        <CountryAssistanceSeekingPOAPanel
          data={ data }
          key={ key }
          type={ key }
          countryName={ this.props.countryName }
          reportSourceYear={ this.state.reportSourceYear }
          thematicDict={ this.props.thematicDict }
          defaultColor={ this.props.defaultColor }
        />
      )
    });
  }

  render() {
    if (this.state.assistanceNeeds === null || this.props.hide) return null;

    return <div>{ this.renderPanels() }</div>;
  }
}

export default CountryAssistanceSeekingPOA;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceSeekingPOA.js